import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('biennale');

const GET_ARTS = define('GET_ARTS', true);
const GET_ART = define('GET_ART', true);
const CREATE_ART = define('CREATE_ART', true);
const UPDATE_ART = define('UPDATE_ART', true);

const GET_ART_PLANS = define('GET_ART_PLANS', true);
const GET_ART_PLAN = define('GET_ART_PLAN', true);
const CREATE_ART_PLAN = define('CREATE_ART_PLAN', true);
const UPDATE_ART_PLAN = define('UPDATE_ART_PLAN', true);

const GET_ARTISTS = define('GET_ARTISTS', true);
const GET_ARTIST = define('GET_ARTIST', true);
const CREATE_ARTIST = define('CREATE_ARTIST', true);
const UPDATE_ARTIST = define('UPDATE_ARTIST', true);

const GET_ART_COMMUNITIES = define('GET_ART_COMMUNITIES', true);
const GET_ART_COMMUNITY = define('GET_ART_COMMUNITY', true);
const CREATE_ART_COMMUNITY = define('CREATE_ART_COMMUNITY', true);
const UPDATE_ART_COMMUNITY = define('UPDATE_ART_COMMUNITY', true);

const initialState = {
  art: {
    loadingArts: true,
    arts: [],
    loadingArt: true,
    art: {}
  },
  artPlan: {
    loadingArtPlans: true,
    artPlans: [],
    loadingArtPlan: true,
    artPlan: {}
  },
  artist: {
    loadingArtists: true,
    artists: [],
    loadingArtist: true,
    artist: {}
  },
  artCommunity: {
    loadingArtCommunities: true,
    artCommunities: [],
    loadingArtCommunity: true,
    artCommunity: {}
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ARTS.PENDING:
      return {
        ...state,
        art: {
          ...state.art,
          loadingArts: true,
          arts: []
        }
      };
    case GET_ARTS.RESOLVED:
      return {
        ...state,
        art: {
          ...state.art,
          loadingArts: false,
          arts: action.data
        }
      };
    case GET_ART.PENDING:
      return {
        ...state,
        art: {
          ...state.art,
          loadingArt: true,
          art: {}
        }
      };
    case GET_ART.RESOLVED:
      return {
        ...state,
        art: {
          ...state.art,
          loadingArt: false,
          art: action.data
        }
      };
    case GET_ART_PLANS.PENDING:
      return {
        ...state,
        artPlan: {
          ...state.art,
          loadingArtPlans: true,
          artPlans: []
        }
      };
    case GET_ART_PLANS.RESOLVED:
      return {
        ...state,
        artPlan: {
          ...state.artPlan,
          loadingArtPlans: false,
          artPlans: action.data
        }
      };
    case GET_ART_PLAN.PENDING:
      return {
        ...state,
        artPlan: {
          ...state.artPlan,
          loadingArtPlan: true,
          artPlan: {}
        }
      };
    case GET_ART_PLAN.RESOLVED:
      return {
        ...state,
        artPlan: {
          ...state.artPlan,
          loadingArtPlan: false,
          artPlan: action.data
        }
      };
    case GET_ARTISTS.PENDING:
      return {
        ...state,
        artist: {
          ...state.artist,
          loadingArtists: true,
          artists: []
        }
      };
    case GET_ARTISTS.RESOLVED:
      return {
        ...state,
        artist: {
          ...state.artist,
          loadingArtists: false,
          artists: action.data
        }
      };
    case GET_ARTIST.PENDING:
      return {
        ...state,
        artist: {
          ...state.artist,
          loadingArtist: true,
          artist: {}
        }
      };
    case GET_ARTIST.RESOLVED:
      return {
        ...state,
        artist: {
          ...state.artist,
          loadingArtist: false,
          artist: action.data
        }
      };
    case GET_ART_COMMUNITIES.PENDING:
      return {
        ...state,
        artC: {
          ...state.artCommunity,
          loadingArtCommunities: true,
          artCommunities: []
        }
      };
    case GET_ART_COMMUNITIES.RESOLVED:
      return {
        ...state,
        artCommunity: {
          ...state.artCommunity,
          loadingArtCommunities: false,
          artCommunities: action.data
        }
      };
    case GET_ART_COMMUNITY.PENDING:
      return {
        ...state,
        artCommunity: {
          ...state.artCommunity,
          loadingArtCommunity: true,
          artCommunity: {}
        }
      };
    case GET_ART_COMMUNITY.RESOLVED:
      return {
        ...state,
        artCommunity: {
          ...state.artCommunity,
          loadingArtCommunity: false,
          artCommunity: action.data
        }
      };
    default: return state;
  }
};

export const actions = {
  getArts: () => ({
    type: GET_ARTS,
    promise: api.get('/biennale/arts'),
    error: 'Unable to get arts'
  }),
  getArt: (id) => ({
    type: GET_ART,
    promise: api.get(`/biennale/arts/${id}`),
    error: 'Unable to get art'
  }),
  createArt: (data) => ({
    type: CREATE_ART,
    promise: api.post('/biennale/arts', data),
    success: 'Art has been created',
    error: 'Unable to create art'
  }),
  updateArt: (id, data) => ({
    type: UPDATE_ART,
    promise: api.put(`/biennale/arts/${id}`, data),
    success: 'Art has been updated',
    error: 'Unable to update art'
  }),
  getArtPlans: () => ({
    type: GET_ART_PLANS,
    promise: api.get('/biennale/art-plans'),
    error: 'Unable to get art plans'
  }),
  getArtPlan: (id) => ({
    type: GET_ART_PLAN,
    promise: api.get(`/biennale/art-plans/${id}`),
    error: 'Unable to get art plan'
  }),
  createArtPlan: (data) => ({
    type: CREATE_ART_PLAN,
    promise: api.post('/biennale/art-plans', data),
    success: 'Art plan has been created',
    error: 'Unable to create art plan'
  }),
  updateArtPlan: (id, data) => ({
    type: UPDATE_ART_PLAN,
    promise: api.put(`/biennale/art-plans/${id}`, data),
    success: 'Art plan has been updated',
    error: 'Unable to update art plan'
  }),
  getArtists: () => ({
    type: GET_ARTISTS,
    promise: api.get('/biennale/artists'),
    error: 'Unable to get artists'
  }),
  getArtist: (id) => ({
    type: GET_ARTIST,
    promise: api.get(`/biennale/artists/${id}`),
    error: 'Unable to get artist'
  }),
  createArtist: (data) => ({
    type: CREATE_ARTIST,
    promise: api.post('/biennale/artists', data),
    success: 'Artist has been created',
    error: 'Unable to create artist'
  }),
  updateArtist: (id, data) => ({
    type: UPDATE_ARTIST,
    promise: api.put(`/biennale/artists/${id}`, data),
    success: 'Artist has been updated',
    error: 'Unable to update artist'
  }),
  getArtCommunities: () => ({
    type: GET_ART_COMMUNITIES,
    promise: api.get('/biennale/art-communities'),
    error: 'Unable to get art communities'
  }),
  getArtCommunity: (id) => ({
    type: GET_ART_COMMUNITY,
    promise: api.get(`/biennale/art-communities/${id}`),
    error: 'Unable to get art community'
  }),
  createArtCommunity: (data) => ({
    type: CREATE_ART_COMMUNITY,
    promise: api.post('/biennale/art-communities', data),
    success: 'Artist has been created',
    error: 'Unable to create art community'
  }),
  updateArtCommunity: (id, data) => ({
    type: UPDATE_ART_COMMUNITY,
    promise: api.put(`/biennale/art-communities/${id}`, data),
    success: 'Artist has been updated',
    error: 'Unable to update art community'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/biennale.js